import { GetRarePassHistoryResponse } from '../../types/character';

export const getRarePassHistoryModel = (
  response: GetRarePassHistoryResponse
): GetRarePassHistoryResponse => {
  return response;
};
